import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa'

import SocialBtn from './SocialBtn'
import Title from '../title/Title'
import './social.css'

const SocialMenu = ({social}) => {

      if(social.data) return 

      return (
            <div className="social_content">
                  <Title text={`Social Networks`}/>
                  <div className="social_menu">
                        <SocialBtn link={social.facebook === '' ? "https://www.facebook.com" : social.facebook} icon={<FaFacebookF />} />
                        <SocialBtn link={social.twitter === '' ? "https://www.twitter.com" : social.twitter} icon={<FaTwitter />} />
                        <SocialBtn link={social.instagram === '' ? "https://www.instagram.com" : social.instagram} icon={<FaInstagram />} />
                        <SocialBtn link={social.youtube === '' ? "https://www.youtube.com" : social.youtube} icon={<FaYoutube />} />
                        <SocialBtn link={social.tiktok === '' ? "https://www.tiktok.com" : social.tiktok} icon={<FaTiktok />} />
                  </div>
            </div>
      )
}

export default SocialMenu
